import React, { forwardRef } from "react";
import { Paper } from "@mui/material";

const DSPaper = forwardRef<HTMLDivElement, React.ComponentProps<typeof Paper>>(
  (props, ref) => <Paper ref={ref} {...props} />,
);

export default DSPaper;
